module.exports = __webpack_public_path__ + "static/media/charge.0426f358.png";